import { render, staticRenderFns } from "./CariGuncelle.vue?vue&type=template&id=89410f6e&"
import script from "./CariGuncelle.vue?vue&type=script&lang=js&"
export * from "./CariGuncelle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports